import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { RenderInput } from './Base';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';
import { getYearsArray } from '../../../../helpers/functions';

import { saveProgress } from '../../../../redux/actions/progress.actions';

const mapStateToProps = (state, ownProps) => ({
    general: state.general,
    progress: state.progress
});

class AddProgressModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            education_level: '',
            student_status: '',
            year_begin: new Date().getFullYear(),
            progress_notes: ''
        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
        this.years = getYearsArray();
    }
    componentDidMount() {
        window.addEventListener('open-progress-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-progress-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { progress: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    setStudentStatusValue = ( form ) => {
        const studentStatus = this.props.general.studentStatuses;
        for (const key of Object.keys(studentStatus)) {
            if (form.student_status === studentStatus[key]) {
                form.student_status = key;
            }
        }
    }
    openModal = event => {
        const { detail } = event;
        const form = detail.id ? { ...detail } : { ...detail, ...this.emptyForm };
        this.setStudentStatusValue(form);
        this.setState({ showModal: true, form });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value }) => {
        const { form } = this.state;
        form[value] = text;
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveProgress();
        }
    }
    saveProgress = () => {
        const { form } = this.state;
        const { saveProgress, general: { studentStatuses }} = this.props;
        if (!form['student_status']) {
            form['student_status'] = Object.keys(studentStatuses)[0];
        }
        saveProgress({ ...form });
    }
    render() {
        const { showModal, form } = this.state;
        const { studentStatuses } = this.props.general;
        const { saveLoading } = this.props.progress;
        return (
            <Dialog icon='timeline-events'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Add Student Progress">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="School Start"
                                    name="year_begin"
                                    value={form.year_begin}
                                    type="select"
                                    items={this.years}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Education Level"
                                    name="education_level"
                                    value={form.education_level}
                                    autoFocus
                                    onChangeHandler={this.onChangeHandler} />
                                <div className="flex-column">
                                    <label className="pt-label">
                                        Student Status
                                        <div className="pt-select">
                                            <select value={form.student_status} onChange={event => this.onChangeHandler({ text: event.target.value, value: 'student_status' })}>
                                                { Object.keys(studentStatuses).map((key, i) => {
                                                    return (
                                                        <option key={i} value={key}>{studentStatuses[key]}</option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Progress Notes"
                                    name="progress_notes"
                                    value={form.progress_notes}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Add Student Progress" onClick={this.saveProgress} isLoading={saveLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveProgress }
)(AddProgressModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/ProgressModal.jsx